import React, { useEffect, useState } from 'react';
import {
 Card,
 CardBody,
 CardTitle,
 Table,
 Button,
 Row,
 Col,
 Spinner
} from 'reactstrap';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";

const InstitutionsList = (props) => {
 const [institutions, setInstitutions] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
   props.setBreadcrumbItems('المؤسسات', [
     { title: "الرئيسية", link: "/dashboard" },
     { title: "المؤسسات", link: "#" }
   ]);
 }, [props]);

 useEffect(() => {
   fetchInstitutions();
 }, []);

 const fetchInstitutions = async () => {
   try {
     const response = await api.get('/institutions');
     setInstitutions(response.data.data);
   } catch (error) {
     console.error('Error fetching institutions:', error);
   } finally {
     setLoading(false);
   }
 };

 const handleDelete = async (id) => {
   if (!window.confirm("هل أنت متأكد من حذف هذه المؤسسة؟")) return;
   try {
     await api.delete(`/institutions/${id}`);
     alert("تم حذف المؤسسة بنجاح");
     fetchInstitutions();
   } catch (error) {
     console.error('فشل حذف المؤسسة:', error);
     alert("حدث خطأ أثناء حذف المؤسسة");
   }
 };

 return (
   <React.Fragment>
     <Card>
       <CardBody>
         <Row className="mb-4">
           <Col md={6}>
             <CardTitle className="h4">قائمة المؤسسات</CardTitle>
           </Col>
           <Col md={6} className="text-end">
             <Link to="/dashboard/institutions/create">
               <Button color="primary">
                 <i className="mdi mdi-plus me-1"></i> إضافة مؤسسة جديدة
               </Button>
             </Link>
           </Col>
         </Row>

         {loading ? (
           <div className="text-center">
             <Spinner color="primary" />
           </div>
         ) : (
           <div className="table-responsive">
             <Table className="table align-middle table-bordered table-striped">
               <thead>
                 <tr>
                   <th>#</th>
                   <th>اسم المؤسسة</th>
                   <th>المدينة/المنطقة</th>
                   <th>رقم الجوال</th>
                   <th>البريد الإلكتروني</th>
                   <th style={{width: '200px'}}>إجراءات</th>
                 </tr>
               </thead>
               <tbody>
                 {institutions.length === 0 ? (
                   <tr>
                     <td colSpan="6" className="text-center">لا توجد مؤسسات حالياً</td>
                   </tr>
                 ) : (
                   institutions.map((inst, index) => (
                     <tr key={inst.id}>
                       <td>{index + 1}</td>
                       <td>{inst.title}</td>
                       <td>{inst.city_or_area || '-'}</td>
                       <td>{inst.mobile1 || '-'}</td>
                       <td>{inst.email || '-'}</td>
                       <td>
                         <div className="d-flex gap-1">
                           <Link to={`/dashboard/institutions/view/${inst.id}`}>
                             <Button size="sm" color="success" className="me-1">
                               <i className="mdi mdi-eye me-1"></i>
                               عرض
                             </Button>
                           </Link>
                           
                           <Link to={`/dashboard/institutions/edit/${inst.id}`}>
                             <Button size="sm" color="info" className="me-1">
                               <i className="mdi mdi-pencil me-1"></i>
                               تعديل
                             </Button>
                           </Link>

                           <Button
                             size="sm"
                             color="warning"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/institutions/print/${inst.id}`, '_blank')}
                           >
                             <i className="mdi mdi-file-pdf me-1"></i>
                             PDF
                           </Button>

                           <Button
                             size="sm"
                             color="secondary"
                             className="me-1"
                             onClick={() => window.open(`/dashboard/institutions/print/${inst.id}`, '_blank')}
                           >
                             <i className="mdi mdi-printer me-1"></i>
                             طباعة
                           </Button>
                           
                           <Button
                             size="sm"
                             color="danger"
                             onClick={() => handleDelete(inst.id)}
                           >
                             <i className="mdi mdi-delete me-1"></i>
                             حذف
                           </Button>
                         </div>
                       </td>
                     </tr>
                   ))
                 )}
               </tbody>
             </Table>
           </div>
         )}
       </CardBody>
     </Card>
   </React.Fragment>
 );
};

export default connect(null, { setBreadcrumbItems })(InstitutionsList);